module.exports = __webpack_public_path__ + "img/39000.480efe79.jpg";